import axios from "axios";
import { StorageUtil } from "./storageUtil";

export const Headers = {
	multipart: {
		"Content-Type": "multipart/form-data",
	},
};

export const meta = {
	baseURL: process.env.REACT_APP_API_BASE,
	// TODO: we need to handle this with env variable, this is anyway soon will be redirecting to new portal
	portalBaseUrl: "https://portal.whizdm.com/loans",
};

export const localApiEndpoint = StorageUtil.getData("api-endpoint");

const instance = axios.create({
	baseURL: localApiEndpoint ?? meta.baseURL,
	validateStatus: function (status) {
		return status >= 200 && status < 300;
	},
});

export const axiosFetch = {
	get: instance.get,
	post: instance.post,
};

export default instance;
